import React from 'react';
import moment from 'moment';
import { getDollarFormat } from 'utils/helpers';
import NoDataMsg from 'library/noData';

const Body = ({ aggregateBranches, endDate, beginDate }) => (

    <div>
        {
            aggregateBranches.list && aggregateBranches.list.length <= 0 ?
                //If there's NO DATA to display
                <NoDataMsg />
                :
                aggregateBranches.list && aggregateBranches.list.length > 0 &&
                //If there's DATA
                <div>
                    <div className="row m-0">
                        <div className="text-center list_header">
                            {beginDate ?
                                <p><i>From</i> <b>{moment(beginDate).format('MMMM Do, YYYY')}</b> <i> to </i>
                                    {endDate ? <b>{moment(endDate).format('MMMM Do, YYYY')}</b> : moment().format('MMMM Do, YYYY')}</p>
                                : ""}
                        </div>
                    </div>
                    <div className="table-responsive">

                        <div className="row m-0 mb-2" >

                            <div className="col-lg-12 title_summary">
                                <h3 className="m-0 text-center text-justify">SUMMARY</h3>
                            </div>{/* row - Date */}

                            <div className="col-lg-2 text-center border-right">
                                <label>Total Items Sold</label>
                                <h3 className="m-0 purple-text size_1-3vmax ">{aggregateBranches.totalQTYSold}</h3>
                            </div> {/* Column Orders */}

                            <div className="col-lg-2 text-center border-right">
                                <label>Total Net Sales</label>
                                <h3 className="m-0 purple-text size_1-3vmax ">{getDollarFormat(aggregateBranches.totalNetSales)}</h3>
                            </div> {/* Column Orders */}

                            <div className="col-lg-2 text-center border-right">
                                <label>Total Gross Sales</label>
                                <h3 className="m-0 purple-text size_1-3vmax ">{getDollarFormat(aggregateBranches.totalGrossSales)}</h3>
                            </div> {/* Column Orders */}

                            <div className="col-lg-2 text-center border-right">
                                <label>Total Cost</label>
                                <h3 className="m-0 purple-text size_1-3vmax ">{getDollarFormat(aggregateBranches.totalCost)}</h3>
                            </div> {/* Column Orders */}

                            <div className="col-lg-2 text-center border-right">
                                <label>Total Profit</label>
                                <h3 className="m-0 purple-text size_1-3vmax ">{getDollarFormat(aggregateBranches.profit)}</h3>
                            </div> {/* Column Orders */}

                            <div className="col-lg-2 text-center border-right">
                                <label>Gross Margin</label>
                                <h3 className="m-0 purple-text size_1-3vmax ">{aggregateBranches.grossprofitpercentage.toFixed(2)}%</h3>
                            </div> {/* Column Orders */}
                        </div>



                        {
                            aggregateBranches.list.map((item, index) => {

                                return (
                                    <div className="row m-0 mb-2" key={index}>

                                        <div className="col-lg-12 title_th">
                                            <h3 className="m-0">{item.branch}</h3>
                                        </div>{/* row - Date */}

                                        <div className="col-lg-1 text-center border-right">
                                            <label>Items Net Sold</label>
                                            <h3 className="m-0 grey-text size_2vmax ">{item.qtySold}</h3>
                                        </div> {/* Column Orders */}

                                        <div className="col-lg-11 text-center daily_cash border-right">
                                            <div className="row m-0">
                                                <div className="col-lg-10 col-md-4 col-sm-12 col-xs-12 m-0 p-0">

                                                    <div className="col-lg-3 col-md-4 col-sm-4 col-xs-6 col-md- m-0 p-0">
                                                        {/* <div className="table_icon"><ActionStore/></div> */}
                                                        <label>Net Sales</label>
                                                        <h3 className="m-0 grey-text">{getDollarFormat(item.netSales)}</h3>
                                                    </div>

                                                    <div className="col-lg-3 col-md-4 col-sm-4 col-xs-6 col-md- m-0 p-0 border-right">
                                                        {/* <div className="table_icon"><ActionCardGiftcard/></div> */}
                                                        <label>Gross Sales</label>
                                                        <h3 className="m-0 grey-text">{getDollarFormat(item.grosssales)}</h3>
                                                    </div>

                                                    <div className="col-lg-3 col-md-4 col-sm-4 col-xs-6 col-md- m-0 p-0 m-0 p-0">
                                                        {/* <div className="table_icon"><ActionCreditCard/></div> */}
                                                        <label>Cost</label>
                                                        <h3 className="m-0 grey-text">{getDollarFormat(item.amountAtCost)}</h3>
                                                    </div>

                                                    <div className="col-lg-3 col-md-4 col-sm-4 col-xs-6 col-md- m-0 p-0 border-right">
                                                        {/* <div className="table_icon"><ActionCardGiftcard/></div> */}
                                                        <label>Gross Profit</label>
                                                        <h3 className="m-0 grey-text">{getDollarFormat(item.grossProfit)}</h3>
                                                    </div>



                                                </div>
                                                <div className="col-lg-2 col-md-4 col-sm-4 col-xs-6 col-md- m-0 p-0">
                                                    {/* <div className="table_icon"><EditorAttachMoney/></div> */}
                                                    <label>Gross Margin</label>
                                                    <h3 className="m-0 green-text"><strong>{item.grossProfitPercentage.toFixed(2)}%</strong></h3>
                                                </div>
                                            </div>
                                        </div>{/* Column Icons */}
                                    </div>
                                );
                            })
                        }

                    </div>
                </div>
        }
    </div >
);

export default Body;


